import React from 'react';
import styled from 'styled-components';

import DriverJourneysButton from './DriverJourneysButton';
import UnassignButton from './UnassignButton';
import OrderStatus from './OrderStatus';
import MinervaInfo from './MinervaInfo';
import OrderCoreInfo from './OrderCoreInfo';
import OrderLHExpressInfo from './OrderLHExpressInfo';

const unassignedJourneyStatus = ['PENDING_ASSIGNMENT'];
const assignedJourneyStatus = ['ASSIGNED', 'IN_TRANSIT'];

const StatusInfo = ({
  driverId,
  isUnassigning,
  status,
  startTimeFrom,
  onUnassignClick = () => {
    /*noop*/
  },
  isCore,
  isLHExpress,
  isLocked,
  className,
}) => {
  const isPendingAssignment = unassignedJourneyStatus.includes(status);
  const isAssignedNotFinished = assignedJourneyStatus.includes(status);

  return (
    <div className={className}>
      <div>
        <OrderStatus status={status} />
        <OrderCoreInfo isCore={isCore} />
        <OrderLHExpressInfo isLHExpress={isLHExpress} />
        {isPendingAssignment && !isLocked && <MinervaInfo />}
      </div>
      {isAssignedNotFinished && (
        <>
          <div>
            <DriverJourneysButton driverId={driverId} startTimeFrom={startTimeFrom} />
          </div>
          <div>
            <UnassignButton isUnassigning={isUnassigning} onUnassignClick={onUnassignClick} />
          </div>
        </>
      )}
    </div>
  );
};

export default styled(StatusInfo)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
